import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-utilities',
  templateUrl: './utilities.component.html',
  styleUrls: ['./utilities.component.css']
})
export class UtilitiesComponent implements OnInit {

  //inject services
  constructor(private mds: MetaService) { }

  //initialize the component
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Utilities';
    var description = 'RegScale solution for Energy Sector and Utilities';
    var keywords = 'RegScale, Energy Sector, Utilities, Compliance, NERC/CIP, Critical Infrastructure, Supply Chain Risk, IOT';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
